module.exports = __webpack_public_path__ + "static/media/planet-ringed.afc4b77b.svg";